// WishlistPage.js
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getWishlist } from '../utils/api';
import ProductCard from '../components/common/ProductCard';
import { FiHeart } from 'react-icons/fi';

export default function WishlistPage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchWishlist = () => {
    getWishlist().then(r => setProducts(r.data)).finally(() => setLoading(false));
  };

  useEffect(() => { fetchWishlist(); }, []);

  if (loading) return <div className="page-loader"><div className="spinner"/></div>;

  return (
    <div className="container" style={{ padding:'1.5rem 1rem' }}>
      <h1 style={{ fontSize:'1.5rem', fontWeight:700, marginBottom:'1.5rem' }}>❤️ My Wishlist ({products.length})</h1>
      {products.length === 0 ? (
        <div style={{ textAlign:'center', padding:'4rem', color:'var(--text-secondary)' }}>
          <FiHeart size={50} style={{ color:'var(--border)', marginBottom:'1rem' }}/>
          <h3>Your wishlist is empty</h3>
          <Link to="/products" className="btn btn-primary" style={{ marginTop:'1rem' }}>Browse Products</Link>
        </div>
      ) : (
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(220px,1fr))', gap:'1rem' }}>
          {products.map(p => <ProductCard key={p._id} product={p} wishlistIds={[p._id]} onWishlistChange={fetchWishlist}/>)}
        </div>
      )}
    </div>
  );
}
